import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Discontinued",
  "Spare part list": "Spare part list",
  "Download Excel": "Download Excel",
  "Recent search list": "Recent search list",
  "No data": "No data available for the entered search parameters",
  "spare part": "spare part",
  "none": "None",
  "no value": "no value",
  "No results found": "No results found",
  "Spare parts for": "Spare parts for",
  "Could not load cumulated data": "Could not load cumulated data",
  "commissioning part": "commissioning part",
  "wear part": "wear part",
  "Search": "Search",
  "Tk": "Tk",
  "Spare part number": "Spare part number",
  "drawing": "drawing",
  "Products for": "Products for",
  "Available": "Available",
  "MM": "MM",
  "The entered order code is invalid": "The entered order code is invalid",
  "Recommended": "Recommended",
  "No data available for the entered search parameters": "No data available for the entered search parameters",
  "Search spare parts": "Search spare parts",
  "Order code / product root / serial number": "Order code / product root / serial number",
  "Characteristic": "Characteristic",
  "Please enter an order code": "Please enter an order code",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. \nThe instrument may only be maintained and repaired by qualified personnel. \nThe device documentation applicable standards and legal requirements as well as any certificates have to be observed!",
  "Maintenance advice": "Maintenance advice",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "For which product(s) can my spare part be used? \\nFilling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.",
  "tool": "tool",
  "Production numbers": "Production numbers",
  "New alternative": "New alternative",
  "There are no items selected. Please use the checkboxes to make your selection": "Warning",
  "Service segmentation": "Service segmentation",
  "Seg": "Seg",
  "Valid": "Valid",
  "Pos": "Pos",
  "Value": "Value",
  "service segmentation 2": "Parts that require basic knowledge. Successful participation in E+H basic training is a prerequisite.",
  "Phase out date": "Phase out date",
  "service segmentation 1": "Parts that require basic knowledge.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Which spare parts are available for my product? \\nFilling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.",
  "Set filter": "Set filter",
  "Search date": "Search date",
  "Group": "Group",
  "Warning": "There are no items selected. Please use the checkboxes to make your selection",
  "Description": "Description",
  "Cancel": "Cancel",
  "service segmentation 4": "Parts for repair in the factory. Expert knowledge is mandatory.",
  "service segmentation 3": "Parts that require specialised knowledge. Successful participation in E+H advanced training is a prerequisite.",
  "Drawing Position Number": "Drawing position number",
  "Spare parts search": "Find Spare Parts",
  "Confirm": "Confirm",
  "Ordercode too short": "Ordercode too short",
  "Product status": "Product status",
  "Open": "Open",
  "Clear": "Clear",
  "PDF file with assembly instructions": "PDF file with assembly instructions",
  "Search products": "Search products",
  "Export": "Export",
  "Production date": "Production date",
  "Order stop": "Order stop",
  "Calibration until": "Calibration until",
  "PDF file with compatibility information": "PDF file with compatibility information",
  "Add selection to cart": "Add selection to cart",
  "Mounting advices": "Mounting advices",
  "Recommended parts only": "Recommended parts only",
  "not applicable": "open",
  "accessories": "accessories",
  "Cumulative spare parts list": "Cumulative spare parts list",
  "YYYY": "YYYY",
  "Title": "Title",
  "Error": "Error",
  "Ordercode too long": "Ordercode too long",
  "Functions": "Functions",
  "Rec": "Rec",
  "Type": "Type",
  "Spare sensor until": "Spare sensor until",
  "Spare parts until": "Spare parts until",
  "Filter": "Filter",
  "Check all": "Check all",
  "Order code": "Order code",
  "Repair until": "Repair until",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Category code",
  "Phase out": "Phase out",
  'Compatibility advices': 'Additional Documents',
  'Co.': 'Add. Doc.'
} as LocalizedDictionary;
